import authReducer from '../views/backend/Auth/state/auth-slice'
import Mode from '../store/mode/index'
const reducers = {
    auth: authReducer,
    mode: Mode
}
export default reducers;


